// extracted by mini-css-extract-plugin
module.exports = {"container":"NoReport_container__90qIH","icon":"NoReport_icon__27rTe","text":"NoReport_text__Zk35e"};